/** @jsx jsx */
import { Box, Flex, jsx } from 'theme-ui'
import StarEmptyIcon from '~/assets/images/icons/star-empty.inline.svg'
import StarHalfIcon from '~/assets/images/icons/star-half.inline.svg'
import StarIcon from '~/assets/images/icons/star.inline.svg'
import { roundReviewScore } from '~/utils/formatters'

const ReviewStars = ({ score }) => {
  const starCount = roundReviewScore(score, 'half')
  const icons = [1, 2, 3, 4, 5].map((i) => {
    if (i <= starCount) return <StarIcon />
    else if (starCount === i - 0.5) return <StarHalfIcon />
    else return <StarEmptyIcon />
  })

  return (
    <Flex>
      {icons.map((icon, index) => (
        <Box key={`bl-star-${index}`} mx="1px">
          {icon}
        </Box>
      ))}
    </Flex>
  )
}

export default ReviewStars
